/**
 * ThumbnailWithPlayButton Component
 */

import * as playerActions from '../../../../redux/actions/player';
import { makeIsTrackPlaying } from '../../../../redux/selectors/player';

import { connect, MapStateToProps } from 'react-redux';

import Component from './component';

import { getPlayerTracksFromResults } from '../../../../redux/helpers/player';
import { ThumbnailWithPlayButtonProps } from './types';

type OwnProps = Pick<
  ThumbnailWithPlayButtonProps,
  'artist' | 'displayButtonOnHover' | 'title' | 'trackId' | 'trackResult'
>;
type StateProps = Pick<ThumbnailWithPlayButtonProps, 'isPlaying'>;
type DispatchProps = Pick<ThumbnailWithPlayButtonProps, 'pause' | 'play'>;

const makeMapStateToProps = () => {
  const isTrackPlaying = makeIsTrackPlaying();
  const mapStateToProps: MapStateToProps<StateProps, OwnProps, IStoreState> = (state, props) => ({
    isPlaying: isTrackPlaying(state, props),
  });

  return mapStateToProps;
};

const ConnectedThumbnailWithPlayButton = connect<StateProps, DispatchProps, OwnProps, IStoreState>(
  makeMapStateToProps,
  (dispatch, { trackId, trackResult }) => ({
    play: () => {
      if (trackResult) {
        // Ensure that the clicked track is in the queue, which is not guaranteed to be the case.
        // E.g. similar tracks on the search results page aren't automatically added to the queue.
        dispatch(playerActions.addTracksToQueue({ tracks: getPlayerTracksFromResults([trackResult!]) }));
      }
      dispatch(playerActions.playTrackFromQueue({ trackId }));
    },
    pause: () => dispatch(playerActions.pause()),
  }),
  null,
  {
    areStatesEqual: (next, prev) =>
      next.player.isTrackPlaying === prev.player.isTrackPlaying
      && (
        !!next.player.currentTrack
        && !!prev.player.currentTrack
        && next.player.currentTrack.trackId === prev.player.currentTrack.trackId
      ),
  },
)(Component);

export default ConnectedThumbnailWithPlayButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/buttons/ThumbnailWithPlayButton/index.tsx